import {
    getAccount,
    listAccounts
} from './queries';
import {
    createAccount,
    deleteAccount,
    restoreAccount,
    updateAccount,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    Account,
    CreateAccount,
    DeleteAccount,
    GetAccount,
    ListAccounts,
    RestoreAccount,
    UpdateAccount
} from "../types.ts";
import {generateClient} from "aws-amplify/api";

const client = generateClient();

const normalizeFilter = (filter: { [key: string]: string }) => {
    return Object.keys(filter)
                 .reduce((acc: { [key: string]: string }, key: string) => {
                     if (filter[key] !== '' && filter[key] !== undefined) {
                         acc[key] = filter[key];
                     }
                     return acc;
                 }, {});

};

// FNP-555: returns the PAGE — items plus the cursor — not a bare array.
//
// The previous signature took (filter, limit, nextToken) positionally and then
// threw the cursor away with `return ...items`, so the caller had no way to ask
// for page 2 even though the query string has always selected `nextToken`. The
// object argument mirrors PipelinesService.fetchRecords, the migrated reference.
export const fetchRecords = async (query: {
    filter?: { [key: string]: string };
    limit?: number;
    nextToken?: string | null;
}) => {
    const {
        filter,
        limit,
        nextToken
    } = query;

    let transformedFilter = {};
    if (typeof filter !== 'undefined') {
        transformedFilter = normalizeFilter(filter);
    }

    const response = await client.graphql<GraphQLQuery<ListAccounts>>({
                                                                          query: listAccounts,
                                                                          variables: {
                                                                              filter: transformedFilter,
                                                                              limit,
                                                                              nextToken
                                                                          },
                                                                      });
    return {
        items: response.data?.listAccounts.items ?? [],
        nextToken: response.data?.listAccounts.nextToken ?? null,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetAccount>>({
                                                                        query: getAccount,
                                                                        variables: {id},
                                                                    });
    return response.data?.getAccount || undefined;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateAccount>>({
                                                                           query: createAccount,
                                                                           variables: {input: payload},
                                                                       });
    return response.data?.createAccount;
};

export const update = async (id: string, record: Account) => {
    const {
        _created,
        _updated,
        _username,
        _sub,
        ...rest
    } = record;

    const response = await client.graphql<GraphQLQuery<UpdateAccount>>({
                                                                           query: updateAccount,
                                                                           variables: {
                                                                               input: {
                                                                                   ...rest,
                                                                                   id
                                                                               }
                                                                           },
                                                                       });
    return response.data?.updateAccount;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteAccount>>({
                                                                           query: deleteAccount,
                                                                           variables: {input: {id}},
                                                                       });
    return response.data?.deleteAccount;
};

// FNP-383: triggers the console-api restoreAccount mutation (3-step pipeline:
// DDB flip → EventBridge emit → audit-log write). The workflows-api
// restoration playbook (FNP-381) consumes the emitted event to re-enable
// the Cognito user.
export const restoreRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<RestoreAccount>>({
                                                                            query: restoreAccount,
                                                                            variables: {input: {id}},
                                                                        });
    return response.data?.restoreAccount;
};
